import React from "react";
import "antd/dist/antd.css";
import { Layout } from "antd";

import FormPrincial from "../componente-principal/componente-principal";
import "./home.css";

const { Content } = Layout;
const { getHost } = require("../generic/utils/utils");

export default class Home extends React.Component {

  render() {  

    let componentSite;
    let e = getHost();
    let step = 0;
    let needLoad = false;
    let path = window.location.pathname.toString();
    let titulo = "Compártanos su experiencia de viaje";

    
    switch(path.toLocaleLowerCase()){
      case "/atencionclientes":
        titulo = "Compártanos su experiencia de viaje.";
        step = 1;
        needLoad = true;
        break;
      case "/consultaatencioncliente":
        titulo = "Seguimiento de mi requerimiento";
        step = 2;
        needLoad = true;
        break;
      case "/cambiodevolucioncliente":
        titulo = "Devoluciones de pasajes";
        step = 4;
        needLoad = true;
        break;
      default:
        titulo = "Compártanos su experiencia de viaje.";
        step = 1;
        needLoad = true;
        break;
    }

    switch (e) {
      case "turbus":
        componentSite = <Content className="turbus"><FormPrincial titulo={titulo} empresa={"turbus"} linea={1} inStep={step} isLoadable={needLoad}/></Content>
        break;
      case "condor":
        componentSite = <Content className="condor"><FormPrincial titulo={titulo} empresa={"condor"} linea={11} inStep={step}isLoadable={needLoad}/></Content>
        break;
        case "jac":
          componentSite = <Content className="jac"><FormPrincial titulo={titulo} empresa={"jac"} linea={26} inStep={step}isLoadable={needLoad}/></Content>
          break;
          case "biobio":
            componentSite = <Content className="biobio"><FormPrincial titulo={titulo} empresa={"biobio"} linea={14} inStep={step}isLoadable={needLoad}/></Content>
            break;
      default:
        componentSite = <Content className="turbus"><FormPrincial titulo={titulo} empresa={"turbus"} linea={1} inStep={step}isLoadable={needLoad}/></Content>
        break;
    }
    
    return (
      <Layout className="layout" style={{ textAlign: "center", width: "100%", height: "100%" }}>
        {componentSite}
      </Layout>
    );
  }
}